import React from 'react';
import { Box, Group, Loader, Alert, Paper, Table, Text, Badge } from '@mantine/core';
import { DialogErrorAlert } from '../DialogErrorAlert';

export interface BindingItem {
    Entity?: string;
    entity?: string;
    Attribute?: string;
    attribute?: string;
    Description?: string;
    description?: string;
    Required?: boolean;
    required?: boolean;
}

interface EntityDetailBindingsTabProps {
    bindings: BindingItem[];
    bindingsLoading: boolean;
    bindingsError: string | null;
}

export const EntityDetailBindingsTab: React.FC<EntityDetailBindingsTabProps> = ({
    bindings,
    bindingsLoading,
    bindingsError
}) => (
    <Box>
        {bindingsLoading ? (
            <Group justify="center" align="center" py="sm">
                <Loader size={24} />
                <Text size="sm" c="dimmed" ml="sm">
                    Loading bindings...
                </Text>
            </Group>
        ) : bindingsError ? (
            <DialogErrorAlert error={bindingsError} />
        ) : bindings.length === 0 ? (
            <Alert color="blue">
                No bindings found for this attribute
            </Alert>
        ) : (
            <Paper withBorder p="xs" mb="sm">
                <Table>
                    <Table.Thead>
                        <Table.Tr>
                            <Table.Th><strong>Entity</strong></Table.Th>
                            <Table.Th><strong>AttributeId</strong></Table.Th>
                            <Table.Th><strong>Description</strong></Table.Th>
                            <Table.Th><strong>Required</strong></Table.Th>
                        </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                        {bindings.map((binding: BindingItem, index: number) => (
                            <Table.Tr key={index}>
                                <Table.Td>
                                    <Text size="sm" ff="monospace">
                                        {binding.Entity || binding.entity || '—'}
                                    </Text>
                                </Table.Td>
                                <Table.Td>
                                    <Text size="sm" ff="monospace">
                                        {binding.Attribute || binding.attribute || '—'}
                                    </Text>
                                </Table.Td>
                                <Table.Td>
                                    <Text size="sm" c="dimmed">
                                        {binding.Description || binding.description || 'No description'}
                                    </Text>
                                </Table.Td>
                                <Table.Td>
                                    {binding.Required || binding.required ? (
                                        <Badge color="red" variant="light" size="sm">Yes</Badge>
                                    ) : (
                                        <Badge color="gray" variant="light" size="sm">No</Badge>
                                    )}
                                </Table.Td>
                            </Table.Tr>
                        ))}
                    </Table.Tbody>
                </Table>
            </Paper>
        )}
    </Box>
);
